import React from 'react'
import { Fab, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { Loader } from 'packages/eid-ui'

const StyledFab = styled(Fab)(({ theme, styles }) => ({
    margin: theme.spacing(1),
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '31px !important',
    color: '#ffffff !important',
    backgroundColor: '#0057A0',
    lineHeight: 0,

    '&:hover': {
        backgroundColor: '#0057A0',
    },
    ...styles,
}))

const StyledIcon = styled(Icon)({
    marginLeft: 6,
})

const RoundedButton = ({ styles, children, loading, ...rest }) => {
    return (
        <StyledFab variant="extended" size="small" styles={styles} {...rest}>
            {loading ? (
                <Loader color={'#ffffff'} />
            ) : (
                <>
                    {children}
                    <StyledIcon
                        name="ArrowSmall"
                        color={styles?.color ? styles.color : '#ffffff'}
                        fill={styles?.color ? styles.color : '#ffffff'}
                        direction="right"
                    ></StyledIcon>
                </>
            )}
        </StyledFab>
    )
}

export default RoundedButton
